import { pageNameFor } from '@shared/page-names';

/** Links up to this long show in full; longer ones show a short label, with the URL on hover. */
export const TASK_LINK_FULL_MAX = 48;

/** Outside sites with a name of their own, by host. */
const KNOWN_HOSTS: Array<{ test: (url: URL) => boolean; label: string }> = [
  { test: (u) => u.hostname === 'adsmanager.facebook.com', label: 'Ads Manager' },
  { test: (u) => u.hostname === 'business.facebook.com' && u.pathname.startsWith('/adsmanager'), label: 'Ads Manager' },
];

/**
 * The text a link in a task shows (R-138): short links as they are; long ones as a known site's name
 * ("Ads Manager"), a jflo page's name ("Products › Collections"), or else the site and "…".
 */
export function taskLinkLabel(href: string, appOrigin: string): string {
  if (href.length <= TASK_LINK_FULL_MAX) return href;
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return href;
  }
  const known = KNOWN_HOSTS.find((k) => k.test(url));
  if (known) return known.label;
  const jflo = url.origin === appOrigin || url.hostname === 'jflo.app';
  if (jflo) {
    const page = pageNameFor(`${url.pathname}${url.search}`);
    if (page) return page;
  }
  return `${url.hostname.replace(/^www\./, '')}/…`;
}
